export {default} from './EarnedCabReport';
